import React from 'react';
import DocumentForm from "./Form";

const path = '/dashboard/documents';

// Use lazy to break circular dependency with ./index
const Documents = React.lazy(() => import('./index'));

const routes = [
  {
    name: "Documents",
    path: `${path}`,
    icon: "users",
    component: Documents,
  },
  {
    name: "Documents Form",
    path: [
      `${path}/create`,
      `${path}/:id`,
      `${path}/:id/update`,
    ],
    icon: "users",
    component: DocumentForm,
  },
];

export default routes;

export const redirects = [
  {
    from: `${path}/*`,
    to: `${path}`,
  },
];
